import { render } from "./reservationCompleted.vue?vue&type=template&id=702944b6&scoped=true"
import script from "./reservationCompleted.vue?vue&type=script&lang=js"
export * from "./reservationCompleted.vue?vue&type=script&lang=js"

import "./reservationCompleted.vue?vue&type=style&index=0&id=702944b6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-702944b6"]])

export default __exports__